<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item :label="language['PlatForm.employee.columns.workNo']">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <a-input :placeholder="language['PlatForm.employee.pleaseSetWorkNo']" v-model="queryParam.workNo" allowClear></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item :label="language['column.gender']">
              <a-select v-model="queryParam.sex" :placeholder="language['warning.genderRequired']" allowClear>
                <a-select-option value="1">{{language['common.sex.man']}}</a-select-option>
                <a-select-option value="2">{{language['common.sex.woman']}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <template v-if="toggleSearchStatus">
            <a-col :md="6" :sm="8">
              <a-form-item :label="language['column.realName']">
                <a-input :placeholder="language['PlatForm.employee.pleaseEnterRealName']" v-model="queryParam.realname" allowClear></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="language['column.cellphoneNumber']">
                <a-input :placeholder="language['warning.phoneNumberIncorrect']" v-model="queryParam.phone" allowClear></a-input>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="language['PlatForm.employee.columns.isResigned']">
                <a-select v-model="queryParam.isResigned" :placeholder="language['column.pleaseChoose']" allowClear>
                  <a-select-option value="0">{{language['common.no']}}</a-select-option>
                  <a-select-option value="1">{{language['common.yes']}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :label="language['PlatForm.employee.columns.isUser']">
                <a-select v-model="queryParam.isUser" :placeholder="language['column.pleaseChoose']" allowClear>
                  <a-select-option value="0">{{language['common.no']}}</a-select-option>
                  <a-select-option value="1">{{language['common.yes']}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? language['common.foldButton'] : language['common.unfoldButton'] }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <a-button @click="handleAdd" type="primary" icon="plus" >{{language['common.insertButton']}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button>-->
     <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <j-third-app-button biz-type="user" :selected-row-keys="selectedRowKeys" syncToApp syncToLocal @sync-finally="onSyncFinally"/>
      <a-button type="primary" icon="hdd" @click="recycleBinVisible=true">{{language['common.recycleBin']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel"/>
            {{language['common.delete']}}
          </a-menu-item>
          <a-menu-item key="2">
            <a-icon type="lock" @click="batchFrozen('2')"/>
            {{language['downBoxValue.freeze']}}
          </a-menu-item>
          <a-menu-item key="3">
            <a-icon type="unlock" @click="batchFrozen('1')"/>
            {{language['common.thawButton']}}
          </a-menu-item>
          <a-menu-item key="4">
            <a-icon type="unlock"/>
            {{language['PlatForm.employee.toUser']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
      <!--<j-super-query :fieldList="superQueryFieldList" @handleSuperQuery="handleSuperQuery"/>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{language['common.choosed']}}&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>
        <template slot="isResigned" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            {{ text === '1' ? language['common.yes'] : language['common.no'] }}
          </div>
        </template>
        <template slot="status" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            {{ text === 1 ? language['downBoxValue.normal'] : language['downBoxValue.freeze'] }}
          </div>
        </template>


        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" >{{language['common.edit']}}</a>

          <a-divider type="vertical" v-if="record.status==1&&record.isUser==='0'"/>
            <a href="javascript:;" @click="toUser(record)"v-if="record.status==1&&record.isUser==='0'">{{language['PlatForm.employee.toUser']}}</a>
           <a-divider type="vertical" />

          <a-dropdown>
            <a class="ant-dropdown-link">
              {{language['common.more']}} <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <!--<a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>-->

              <!--<a-menu-item v-if="record.status==1">
                <a href="javascript:;" @click="toUser(record)">转用户</a>
              </a-menu-item>-->

              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==1">
                <a-popconfirm :title="language['tip.messageSureToFreeze']" @confirm="() => handleFrozen(record.id,2,record.username)">
                  <a>{{language['downBoxValue.freeze']}}</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==2">
                <a-popconfirm :title="language['tip.messageSureToThaw']" @confirm="() => handleFrozen(record.id,1,record.username)">
                  <a>{{language['common.thawButton']}}</a>
                </a-popconfirm>
              </a-menu-item>

              <!--<a-menu-item>
                <a href="javascript:;" @click="handleAgentSettings(record.username)">代理人</a>
              </a-menu-item>-->

            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <sys-bm-employee-modal ref="modalForm" @ok="modalFormOk"></sys-bm-employee-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>

    <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal>

    <!-- 用户回收站 -->
    <employee-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk"/>

  </a-card>
</template>

<script>
  import EmployeeRecycleBinModal from './modules/EmployeeRecycleBinModal'
  import PasswordModal from './modules/PasswordModal'
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch,duplicateCheck} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import SysUserAgentModal from "./modules/SysUserAgentModal";
  import JInput from '@/components/jeecg/JInput'
  import SysBmEmployeeModal from './modules/SysBmEmployeeModal'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'

  export default {
    name: "EmployeeList",
    mixins: [JeecgListMixin],
    components: {
      JThirdAppButton,
      SysUserAgentModal,
      PasswordModal,
      JInput,
      EmployeeRecycleBinModal,
      JSuperQuery,
      SysBmEmployeeModal
    },
    data() {
      return {
        queryParam: {},
        recycleBinVisible: false,
        uploadSource:"platform",

        superQueryFieldList: [
          { type: 'input', value: 'username', text: '用户账号', },
          { type: 'input', value: 'realname', text: '用户姓名', },
          { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' },
        ],
        url: {
          list: "/sys/employee/list",
          delete: "/sys/employee/delete",
          deleteBatch: "/sys/employee/deleteBatch",
          exportXlsUrl: "/sys/employee/exportXls",
          importExcelUrl: "sys/employee/importExcel",
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: this.language['PlatForm.employee.columns.workNo'],
              align: "center",
              dataIndex: 'workNo',
              width: 120,
              sorter: true
            },
            {
              title: this.language['user.column.userName'],
              align: "center",
              width: 100,
              dataIndex: 'realname',
            },
            {
              title: this.language['user.column.Avatar'],
              align: "center",
              width: 120,
              dataIndex: 'avatar',
              scopedSlots: {customRender: "avatarslot"}
            },

            {
              title: this.language['column.gender'],
              align: "center",
              width: 80,
              dataIndex: 'sex_dictText',
              sorter: true
            },
            {
              title: this.language['user.column.birthday'],
              align: "center",
              width: 100,
              dataIndex: 'birthday'
            },
            {
              title: this.language['column.cellphoneNumber'],
              align: "center",
              width: 100,
              dataIndex: 'phone'
            },
            /*{
              title: '公司组织',
              align: "center",
              width: 180,
              dataIndex: 'orgCodeText'
            },*/
            {
              title: this.language['PlatForm.employee.columns.joinDate'],
              align: "center",
              width: 180,
              dataIndex: 'joinDate'
            },

            {
              title: this.language['PlatForm.employee.columns.isResigned'],
              align: "center",
              width: 80,
              dataIndex: 'isResigned',
              scopedSlots: {customRender: "isResigned"},
              /*customRender: function(text) {
                if (text === '1') {
                  return '是'
                } else if (text === '0') {
                  return '否'
                }
              }*/
            },
            {
              title: this.language['column.status'],
              align: "center",
              width: 80,
              dataIndex: 'status',
              scopedSlots: {customRender: "status"},
              /*customRender: function(text) {
                if (text === 1) {
                  return '正常'
                } else if (text === 2) {
                  return '冻结'
                }
              }*/
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'},
              align: "center",
              width: 170
            }
          ];
        }
      }


    },
    methods: {
      handleEdit: function(record) {
        this.$refs.modalForm.title = this.language['common.edit']
        this.$refs.modalForm.edit(record)
      },
      handleDetail(record){
        this.$refs.modalForm.title = this.language['common.detailsButton']
        this.$refs.modalForm.disableSubmit = true;
        this.$refs.modalForm.edit(record)
      },
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },

      batchFrozen: function (status) {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord']);
          return false;
        } else {
          let ids = "";
          let that = this;
          let isAdmin = false;
          that.selectionRows.forEach(function (row) {
            if (row.username == 'admin') {
              isAdmin = true;
            }
          });
          if (isAdmin) {
            that.$message.warning(this.language['PlatForm.employee.adminNotAllow']);
            return;
          }
          that.selectedRowKeys.forEach(function (val) {
            ids += val + ",";
          });
          that.$confirm({
            title: this.language['confirm.titleConfirmOperation'],
            content: this.language['content.message.whether'] + (status == 1 ? this.language['common.thawButton'] : this.language['downBoxValue.freeze']) + "?",
            onOk: function () {
              putAction("/sys/employee/frozenBatch",{ids: ids, status: status}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleMenuClick(e) {
        if (e.key == 1) {
          this.batchDel();
        } else if (e.key == 2) {
          this.batchFrozen(2);
        } else if (e.key == 3) {
          this.batchFrozen(1);
        }else if (e.key == 4) {
          this.allToUser();
        }
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning(this.language['PlatForm.employee.adminNotAllow']);
          return;
        }
        putAction("/sys/employee/frozenBatch",{ids: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },
      handleAgentSettings(username){
        this.$refs.sysUserAgentModal.agentSettings(username);
        this.$refs.sysUserAgentModal.title = this.language['PlatForm.employee.UserAgent'];
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      onSyncFinally({isToLocal}) {
        // 同步到本地时刷新下数据
        if (isToLocal) {
          this.loadData()
        }
      },
      allToUser(){
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord']);
          return false;
        }else {
          this.selectionRows.applicationId = this.$store.getters.applicationCode;
          let url = "/sys/employee/allToUser"+"?applicationCode="+this.$store.getters.applicationCode+"&userType=employee";
          putAction(url,this.selectionRows).then((res) => {
            if (res.success) {
                this.$message.success(res.message);
                this.loadData();
              }else{
                let errorlist = res.result;
                if(errorlist){
                  this.$message.error(this.language['PlatForm.employee.columns.workNo']+"("+errorlist.toString()+")"+this.language['warning.usernameAlreadyExists'])
                  /*let value = "";
                  errorlist.forEach(item=>{
                    if(value == ''){
                      value=item
                    }else{
                      value=value+"\n"+item
                    }
                  })
                  this.$message.warning("工号:\n"+value+"\n用户已存在");
                  alert("工号:\n"+value+"\n用户已存在")*/

                }else{
                  this.$message.warning(res.message);
                }
                this.loadData();
              }
          });
        }
      },
      toUser(record){
        var params = {
          tableName: 'sys_user',
          fieldName: 'work_no',
          fieldVal: record.workNo,
          dataId: record.id
        };
        duplicateCheck(params).then((res) => {
          if (res.success) {
            var params = {
              tableName: 'sys_user',
              fieldName: 'username',
              fieldVal: record.workNo,
              dataId: record.id
            };
            duplicateCheck(params).then((res) => {
              if (res.success) {
                let url = "/sys/employee/toUser"+"?applicationCode="+this.$store.getters.applicationCode+"&userType=employee";
                putAction(url,record).then((res) => {
                  if (res.success) {
                    this.$message.success(res.message);
                    this.loadData();
                  } else {
                    this.$message.warning(res.message);
                  }
                });
                // this.$message.success("成功");
              } else {
                this.$message.warning(this.language['PlatForm.employee.columns.workNo']+this.language['warning.usernameAlreadyExists']);
              }
            })
            // this.$message.success("成功");
          } else {
            this.$message.warning(this.language['PlatForm.employee.columns.workNo']+this.language['warning.usernameAlreadyExists']);
          }
        })

      },
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>